
<div class="barigheter pt-3 pb-0">
  @for (barighet of basdata.barigheter; track barighet; let i = $index) {
    <rask-checkbox [text]="barighet.value" [label]="((i===0) ? texts.barighetSkog : '')"
      class="m-0"
      (change)="changeArrayValue(searchFilter.skogligdata.tillganglighet.terrang, barighet, $event)"
      [checked]="hasValue(searchFilter.skogligdata.tillganglighet.terrang, barighet)"
      [ngModel]="hasValue(searchFilter.skogligdata.tillganglighet.terrang, barighet)"
    aid="{{'filterSkogligDataBarighetSkog_' + i}}"></rask-checkbox>
  }
</div>
<div class="radiobuttons pt-0">
  <ng-container>
    <rask-radiobutton-group [buttons]="radioButtonsArbetsorderAtgard.or_and"
      class="ps-1 pb-0 pe-0 pt-0"
      (change)="setOrAndValue($event)"
      [ngModel]="getOrAndValue()"
    aid="filterSkogligDataBarighetSkogOrAnd"></rask-radiobutton-group>
  </ng-container>
</div>
<div class="pt-2">
  @for (barighet of basdata.barigheter; track barighet; let i = $index) {
    <rask-checkbox [text]="barighet.value" [label]="((i===0) ? texts.barighetVag : '')"
      class="m-0"
      (change)="changeArrayValue(searchFilter.skogligdata.tillganglighet.vag, barighet, $event)"
      [checked]="hasValue(searchFilter.skogligdata.tillganglighet.vag, barighet)"
      [ngModel]="hasValue(searchFilter.skogligdata.tillganglighet.vag, barighet)"
    aid="{{'filterSkogligDataBarighetVag_' + i}}"></rask-checkbox>
  }
</div>
